var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"g_id_onload","data-client_id":_vm.clientId,"data-login_uri":"api/users/login/google/","data-redirect_uri":_vm.redirectUri,"data-itp_support":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }